// /src/utils/extractUUID.js

/**
 * Extracts identifier (UUID or friendly name) from URL path
 * @param {string} url - The URL path to extract identifier from
 * @returns {string|null} - Valid identifier or null if invalid/missing
 */
export const extractUUID = (url) => {
    const pathSegments = url.split('/').filter(segment => segment.length > 0);
    
    // If no segments, return null
    if (pathSegments.length === 0) {
        return null;
    }
    
    // Extract the first path segment (the identifier should be the first segment after /)
    const firstSegment = pathSegments[0];
    
    // Remove any query parameters if present
    const identifier = firstSegment.split('?')[0];
    
    // Basic validation: alphanumeric and hyphens/underscores, minimum 3 characters
    // This allows for friendly names like "tdcjerseycity" or UUIDs
    const validIdentifierRegex = /^[a-zA-Z0-9_-]{3,}$/;
    
    if (!identifier || !validIdentifierRegex.test(identifier)) {
        return null;
    }
    
    return identifier;
};

/**
 * Validates if a string is a valid identifier format
 * @param {string} identifier - The identifier to validate
 * @returns {boolean} - True if valid, false otherwise
 */
export const isValidIdentifier = (identifier) => {
    if (!identifier || typeof identifier !== 'string') {
        return false;
    }
    // Allow alphanumeric, hyphens, and underscores, minimum 3 characters
    const validIdentifierRegex = /^[a-zA-Z0-9_-]{3,}$/;
    return validIdentifierRegex.test(identifier);
};